import React, { useState, useEffect } from 'react';
import { EventEmitter } from "events";
import AIChat from '../AIChat/AIChat.js';
import MedboardPdf from '../MedboardPdf/MedboardPdf.jsx';
import '../Shared/Style.css';
import '../TaskManagerApp/App.css';

const hasValue = (field) => field != null && field !== "";

const GlobalDbPdfAiPane = ({
    uniqueId,
    mediaPath,
    translationMediaPath,
    title,
    surveillanceType,
    closePopup = null
}) => {
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(false);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [selectedPDFTab, setSelectedPDFTab] = useState("main");
    const [componentKey, setComponentKey] = useState(0);
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);

    const firstEmitter = new EventEmitter();

    if (!closePopup) {
        closePopup = () => {
            const container = document.getElementById("global-db-pdf-ai-container");
            if (container) {
                container.style.display = "none";
                container.innerHTML = "";
            }
        };
    }

    useEffect(() => {
        setItemDetailsPaneActive(true);
        setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
    }, []);

    const handleClose = () => {
        setItemDetailsPaneOpenEffect(false);
        setTimeout(() => {
            setItemDetailsPaneActive(false);
            closePopup();
        }, 300);
    };

    const callAIChat = () => {
        setAutoCallOverviewFunction(true);
        setComponentKey(prevKey => prevKey + 1);
    };

    const chatApiUrl = "/umbraco/api/DocumentAnalysis/Chat?entityType=global-databases&entityId="
        + encodeURIComponent(uniqueId || "")
        + "&surveillanceType=" + encodeURIComponent(surveillanceType || "");

    const pdfUrl = selectedPDFTab === "translation" && hasValue(translationMediaPath)
        ? translationMediaPath
        : mediaPath;

    if (!itemDetailsPaneActive) {
        return null;
    }

    return (
        <div
            style={{ height: "100vh", overflow: "auto" }}
            className={`slide-pane-full-width ${itemDetailsPaneOpenEffect ? "open" : ""}`}
        >
            <div className="content">
                <div style={{ flex: "1" }}>
                    <div style={{ display: "flex", flexDirection: "row" }}>

                        <div id="pdf-viewer" style={{ flex: 25, paddingRight: "10px", borderRight: "2px solid #f0f0f0", height: "96vh" }}>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%", marginBottom: "5px" }}>
                                <div style={{ flex: 1 }}>
                                    <h3>PDF Viewer</h3>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "end", marginRight: "50px" }}>
                                    <div>
                                        <button onClick={callAIChat} className="medboard-ai-analyzer-button">AI Overview</button>
                                    </div>
                                </div>
                            </div>

                            {hasValue(translationMediaPath) ? (
                                <div style={{ display: "flex", width: "100%", flexDirection: "row", marginBottom: "15px" }}>
                                    <div
                                        onClick={() => setSelectedPDFTab("main")}
                                        style={{ cursor: "pointer", paddingRight: "8px", paddingLeft: "8px" }}
                                        className={selectedPDFTab === "main" ? "pdf-viewer-tab-selected" : "pdf-viewer-tab-unselected"}
                                    >
                                        <i className="fas fa-file-alt"></i> Original
                                    </div>
                                    <div
                                        onClick={() => setSelectedPDFTab("translation")}
                                        style={{ cursor: "pointer", paddingRight: "8px", paddingLeft: "8px" }}
                                        className={selectedPDFTab === "translation" ? "pdf-viewer-tab-selected" : "pdf-viewer-tab-unselected"}
                                    >
                                        <i className="fas fa-language"></i> Translation
                                    </div>
                                    <div style={{ flex: "1 1 0%", borderBottom: "2px solid rgb(240, 240, 240)" }}></div>
                                </div>
                            ) : null}

                            {hasValue(pdfUrl) ? (
                                <div id="pdfviewerdiv" style={{ height: "100%", marginBottom: "30px" }}>
                                    <MedboardPdf
                                        key={selectedPDFTab + (pdfUrl || "")}
                                        updater={firstEmitter}
                                        savedComments={[]}
                                        url={pdfUrl}
                                        showHighlightsButton={false}
                                        showAnnotationsButton={false}
                                        containerHeight={"80vb"}
                                    />
                                </div>
                            ) : (
                                <div style={{ marginTop: "15px" }}>No pdf file found.</div>
                            )}
                        </div>

                        <div id="fields-content" style={{ flex: 20, flexDirection: "column", paddingLeft: "10px", height: "96vh", overflowY: "auto", position: "relative", display: "flex" }}>
                            <div id="multiple-contents" style={{ flex: 1, overflow: "auto", paddingRight: "15px", display: "flex", flexDirection: "column" }}>
                                <div style={{ display: "flex", marginBottom: "10px" }}>
                                    <div style={{ flex: 1, marginRight: "20px" }}>
                                        <h3 style={{ display: 'inline-block', margin: 0, marginRight: '10px' }}>
                                            {hasValue(title) ? title : "Document AI"}
                                        </h3>
                                    </div>
                                    <div>
                                        <button className="close-button" onClick={handleClose}>
                                            <i className="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        width: "100%",
                                        flexDirection: "row",
                                        marginBottom: "15px"
                                    }}
                                >
                                    <div
                                        style={{
                                            cursor: "pointer",
                                            paddingBottom: "3px",
                                            paddingLeft: "8px",
                                            paddingRight: "8px",
                                            borderBottom: "2px solid #00abff"
                                        }}
                                    >
                                        <img src="/assets/images/stars-stroke-rounded-solid.svg" className="ai-icon" style={{ width: "19px", marginTop: "-3px", marginRight: "5px" }} /> AI
                                    </div>
                                    <div style={{ flex: 1, borderBottom: "2px solid #f0f0f0" }}></div>
                                </div>

                                <div style={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: "start", overflow: "auto" }}>
                                    <div style={{ marginBottom: "10px", flex: 1, display: "block" }}>
                                        <div id="aichat-pane" style={{ flex: 1, padding: "0px 10px", borderRight: "2px solid #f0f0f0", height: "100%" }}>
                                            <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                                <AIChat
                                                    key={componentKey}
                                                    entityType="global-databases"
                                                    entityId={uniqueId}
                                                    uniqueId={uniqueId}
                                                    embeddedAIComponent={true}
                                                    autoCallOverviewFunction={autoCallOverviewFunction}
                                                    enableAIOverviewButton={true}
                                                    enableComparisonButton={false}
                                                    enableRequirementsButton={false}
                                                    enableUserChat={true}
                                                    filePath={mediaPath}
                                                    translationMediaPath={translationMediaPath}
                                                    documentTitle={title}
                                                    systematicReviewType={surveillanceType}
                                                    chatApiUrl={chatApiUrl}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GlobalDbPdfAiPane;
